export const THEME_STORAGE_KEY = 'campwhiz-theme-variant';

export const DEFAULT_THEME = {
  primary: '#5200c4',
  secondary: '#E68C35',
  text: '#0d1617',
  logo: '/assets/campwhiz-logo-color2.svg',
  gradientFrom: 'from-purple-50',
  gradientTo: 'to-purple-100',
  buttonBg: 'bg-purple-600',
  buttonHover: 'hover:bg-purple-700',
};

export const THEME_VARIANTS = {
  purple: {
    primary: '#5200c4',
    secondary: '#E68C35',
    text: '#0d1617',
    logo: '/assets/campwhiz-logo-color2.svg',
    gradientFrom: 'from-purple-50',
    gradientTo: 'to-purple-100',
    buttonBg: 'btn-primary',
    buttonHover: 'hover:bg-purple-700',
    buttonSecondary: 'btn-secondary',
  },
  teal: {
    primary: '#64AAAD',
    secondary: '#E68C35',
    text: '#ffffff',
    logo: '/assets/campwhiz-logo-color.svg',
    gradientFrom: 'from-teal-50',
    gradientTo: 'to-teal-100',
    buttonBg: 'btn-primary',
    buttonHover: 'hover:bg-teal-700',
    buttonSecondary: 'btn-secondary',
  },
};
